import React from "react";
import BillingPeriodsDataTable from "./BillingPeriodsDataTable";
import { EnumWrapper } from "../../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../../utils/enums/enums";

const BillingPeriodsPage = () => {
  return (
    <div className="sub-content billing-periods">
      <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
        <BillingPeriodsDataTable />
      </EnumWrapper>
    </div>

  );
};

export default BillingPeriodsPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/billingPeriods/BillingPeriodsPage.js